'use strict';
import "./styles/main.scss";
import "./styles/info.scss";
import "./styles/404.scss";

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({ startEvent: "load" });

import headerScroll from './scripts/modules/headerScroll.js';
import burger from './scripts/modules/burger.js';
import stackedCards from './scripts/modules/stackedCards.js';
import counter from './scripts/modules/counter.js';
import reviewSlider from './scripts/modules/reviewsSlider.js';
import faq from './scripts/modules/faq.js';
import reviewsModal from './scripts/modules/reviewsModal.js';
import form from './scripts/modules/form.js';

document.addEventListener('DOMContentLoaded', () => {
	headerScroll();
	burger();
	stackedCards();
	counter();
	reviewSlider();
	faq();
	reviewsModal();
	form();
});

document.querySelectorAll('img').forEach((img) =>
	img.addEventListener('load', () =>
		AOS.refresh()
	)
);